import { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { useBreadcrumb } from "@accredo/fe-shared/contexts/BreadcrumbContext.jsx";
import SchadenUrsachenTable from "../../../components/tables/SchadenUrsachenTable.jsx";

export default function SchadenUrsachenIndexPage() {
  const { setBreadcrumbs } = useBreadcrumb();

  useEffect(() => {
    setBreadcrumbs([
      { name: "Home", path: "/home" },
      { name: "Einstellungen", path: "/admin/settings" },
      {
        name: "Schadenarten & Schadenursachen",
        path: "/admin/schaden-ursachen",
      },
    ]);
  }, [setBreadcrumbs]);

  return (
    <Box>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h1" gutterBottom>
          Schadenarten & Schadenursachen
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Übersicht aller Schadenursachen mit ihrer Schadenart
        </Typography>
      </Box>

      <SchadenUrsachenTable />
    </Box>
  );
}
